import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { XCircle } from 'lucide-react';

export default function PaymentCancelPage() {
    return (
        <div className="min-h-screen bg-[#F2F5F2] flex items-center justify-center p-4" data-testid="payment-cancel-page">
            <Card className="w-full max-w-md border border-[#CBD5E1] shadow-none">
                <CardContent className="p-8 text-center">
                    <XCircle className="h-12 w-12 text-[#64748B] mx-auto mb-4" />
                    <h1 className="text-xl font-bold text-[#0F172A]" style={{ fontFamily: 'Work Sans, sans-serif' }}>Pagamento annullato</h1>
                    <p className="text-sm text-[#64748B] mt-2 mb-6">Nessun addebito effettuato. Puoi riprovare quando vuoi.</p>
                    <Button asChild className="w-full bg-[#1B4E8E] hover:bg-[#143A6B]" data-testid="payment-cancel-retry">
                        <Link to="/signup">Torna alla registrazione</Link>
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
}
